<template>

    <div>
        <v-rule-group v-for="group in rules"
            :key="group.id"
            :group="group"
            :min="1">
        </v-rule-group>
    </div>

</template>

<script>

import RuleGroup from './rules/RuleGroup';

export default {

    components: {
        'v-rule-group': RuleGroup,
    },

    props: {
        model: {
            type: Object,
        },
    },

    data() {
        return {
            op: this.$store.getters['segmenter/op'],
        }
    },

    mounted() {
        this.$store.commit('segmenter/setType', 'page');
        this.$store.commit('segmenter/setModel', this.model);
        this.$store.commit('segmenter/setOp', this.model.op || 'and');
        this.$store.commit('segmenter/setRules', this.model.rules);
        if (!this.model.rules.length) {
            this.$store.commit('segmenter/addRuleGroup');
        }
    },

    computed: {

        rules() {
            return this.$store.getters['segmenter/rules'];
        },

    },

    watch: {

        op(val) {
            this.$store.commit('segmenter/setOp', val);
        },

    },

}

</script>
